module.exports = __webpack_public_path__ + "static/media/searchIconBlack.c1c83cbf.png";